'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import logo from 'bender-url!../../img/hubspot-tools-logo.png';
import text from 'I18n/utils/unescapedText';

var Logo = function Logo(_ref) {
  var onClick = _ref.onClick;
  var classes = Boolean(onClick) ? "clickable" : "";
  return /*#__PURE__*/_jsx("div", {
    className: "logo",
    children: /*#__PURE__*/_jsx("img", {
      alt: text('altText.logo'),
      className: "" + classes,
      src: logo,
      onClick: onClick
    })
  });
};

Logo.defaultProps = {
  isClickable: false
};
export default Logo;